var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{ref:"modalContentHtml",attrs:{"title":_vm.title,"size":"lg","hide-footer":"","centered":""},on:{"hide":_vm.closeModal}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }